import { UiEvent } from '../utils/ui-event';

export class SwipeTracking {
	constructor() {
		document
			.querySelectorAll('[data-bi-id="content"] .scroll-slider .scroll-slider-wrapper')
			.forEach((item: HTMLElement) => {
				let startX: number = 0;
				let endX: number = 0;

				item.addEventListener('touchstart', (event: TouchEvent) => {
					startX = event.touches[0].clientX;
				});

				item.addEventListener('touchend', (event: TouchEvent) => {
					endX = event.changedTouches[0].clientX;
					const deltaX: number = endX - startX;

					if (Math.abs(deltaX) > 50) {
						const direction: string = deltaX > 0 ? 'right' : 'left';
						UiEvent.trackUIEvent('content', 'slider', 'swipe', direction);
					}
				});
			});

		document.querySelectorAll('.menu .scroll-slider-wrapper').forEach((item: HTMLElement) => {
			let startX: number = 0;
			let endX: number = 0;

			item.addEventListener('touchstart', (event: TouchEvent) => {
				startX = event.touches[0].clientX;
			});

			item.addEventListener('touchend', (event: TouchEvent) => {
				endX = event.changedTouches[0].clientX;
				const deltaX: number = endX - startX;

				if (Math.abs(deltaX) > 50) {
					const direction: string = deltaX > 0 ? 'right' : 'left';
					UiEvent.trackUIEvent('content', 'sub-menu-slider', 'swipe', direction);
				}
			});
		});
	}
}
